import { MutableState } from '../State';
import { PromoID } from './promo.ruleset';

/**
 * Set promo as seen.
 * @param state
 * @param id
 * @param now
 */
export function setPromoSeen(
  state: MutableState,
  id: PromoID,
  now: number,
): void {
  const count = state.promo[id]?.count ?? 0;
  state.promo[id] = {
    shownAt: now,
    active: true,
    count: count + 1,
    claimedRewards: state.promo[id]?.claimedRewards ?? false,
  };
}

export function resetPromoRewards(state: MutableState, id: PromoID): void {
  state.promo[id].claimedRewards = false;
}

/**
 * Reset promo cooldown.
 */
export function resetPromoCooldown(state: MutableState, id: PromoID): void {
  if (!state.promo[id]) {
    return;
  }
  state.promo[id].shownAt = 0;
  state.promo[id].active = true;
}
